import { render, staticRenderFns } from "./Plantilla.vue?vue&type=template&id=5831181c"
import script from "./Plantilla.vue?vue&type=script&lang=js"
export * from "./Plantilla.vue?vue&type=script&lang=js"
import style0 from "./Plantilla.vue?vue&type=style&index=0&id=5831181c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports